// File: src/pages/Failure.jsx
import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function Failure() {
  const navigate = useNavigate();
  const location = useLocation();
  const error =
    location.state?.error ||
    "Payment failed. Please try again or update your payment method.";

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <div className="p-6 border rounded-md bg-white">
        <h1 className="text-2xl font-semibold mb-2 text-red-600">
          Payment failed
        </h1>
        <p className="text-gray-700 mb-4">{error}</p>
        <div className="flex gap-2">
          <button
            onClick={() => navigate(-1)}
            className="px-4 py-2 border rounded-md"
          >
            Try again
          </button>
          <button
            onClick={() => navigate("/dashboard/wallet")}
            className="px-4 py-2 bg-indigo-600 text-white rounded-md"
          >
            Back to Wallet
          </button>
          <button
            onClick={() => navigate("/dashboard/add-credits")}
            className="px-4 py-2 border rounded-md"
          >
            Add Credits Manually
          </button>
        </div>
      </div>
    </div>
  );
}
